import { Link as AriaLink, type LinkProps as AriaLinkProps } from "react-aria-components";
import type { VariantProps } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";
import ExternalIcon from "@/assets/images/icons2/icon--external-link.svg";

import { buttonStyles } from "./Button";

type LinkProps = {
  isExternal?: boolean;
  rawChildren?: boolean;
} & AriaLinkProps &
  Pick<VariantProps<typeof buttonStyles>, "size" | "variant">;

export function Link2({
  children,
  className,
  isExternal,
  rawChildren,
  size,
  variant = "link",
  ...linkProps
}: LinkProps) {
  const { body, content } = buttonStyles({ size, variant });

  return (
    <AriaLink
      className={cn(body(), "atom-focus tw:no-underline!", className)}
      {...(isExternal && { rel: "noopener noreferrer", target: "_blank" })}
      {...linkProps}
    >
      {rawChildren && children}

      {!rawChildren && (
        <>
          <span className={cn(content(), "tw:no-underline!")}>{children}</span>
          {isExternal && <img alt="" className="tw:ml-2 tw:align-text-top!" src={ExternalIcon} />}
        </>
      )}
    </AriaLink>
  );
}
